import { render, staticRenderFns } from "./ItemDetailModal.vue?vue&type=template&id=7e897637&"
import script from "./ItemDetailModal.vue?vue&type=script&lang=js&"
export * from "./ItemDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports